import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { baseUrl } from '../../utils/baseUrl';
import styles from './AtmLocator.module.css'
import * as toast from '../../utils/makeToast'
import GrowingLoader from '../GrowingLoader';


function AtmLocator(props) {

    const [atms, setAtms] = useState([])
    const [branches, setBranches] = useState([])
    const [loading, setLoading] = useState(false)

    const fetchAtms = (latitude, longitude) => {
        const payload = {
            longitude,
            latitude
        }
        axios.post(`${baseUrl}Enum/atms/nearest`, payload)
            .then(response => {
                let tempAtms = response?.data?.data?.atms
                setAtms(
                    tempAtms.map(atm => {
                        return {
                            ...atm,
                            distance: calculateDistance(+latitude, +longitude, +atm.latitude, +atm.longitude)
                        }
                    })
                )
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                toast.errorToast('Something went wrong')
            })
    }

    const fetchBranches = (latitude, longitude) => {
        const payload = {
            longitude,
            latitude
        }
        axios.post(`${baseUrl}Enum/branches/nearest`, payload)
            .then(response => {
                let tempBranches = response?.data?.data?.branches
                setBranches(
                    tempBranches.map(branch => {
                        return {
                            ...branch,
                            distance: calculateDistance(+latitude, +longitude, +branch.latitude, +branch.longitude)
                        }
                    })
                )
                setLoading(false)
            })
            .catch(err => {
                setLoading(false)
                toast.errorToast('Something went wrong')
            })
    }

    const calculateDistance = (lat1, lon1, lat2, lon2) => {
        const earthRadius = 6371; // Radius of the Earth in kilometers
        const dLat = degreesToRadians(lat2 - lat1);
        const dLon = degreesToRadians(lon2 - lon1);
      
        const a =
          Math.sin(dLat / 2) * Math.sin(dLat / 2) +
          Math.cos(degreesToRadians(lat1)) *
            Math.cos(degreesToRadians(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
      
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = earthRadius * c;
      
        return distance;
    }
      
      const degreesToRadians = (degrees) => {
        return (degrees * Math.PI) / 180;
      }


    useEffect(() => {
        setLoading(true)
        const successCallback = (position) => {
            if (props.type.toLowerCase() === 'atm') {
                fetchAtms(position?.coords?.latitude, position?.coords?.longitude)
            }
            else if (props.type.toLowerCase() === 'branch') {
                fetchBranches(position?.coords?.latitude, position?.coords?.longitude)
            }
        };

        const errorCallback = (error) => {
            
        };

        navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
    }, [])


    return (
        <div>
            {loading ? (
                <div>
                    <GrowingLoader />
                </div>
            ) :
                <div className={`${styles.branchListing}`}>
                    {
                        props.type.toLowerCase() === 'atm' &&
                        <div className='mt-5'>
                            {
                                atms.map(atm => {
                                    return (
                                        <div key={atm.id}>
                                            <div className={`d-flex justify-content-between ${styles.location}`}>
                                                <p>{atm.address.toLowerCase() !== 'null' ? atm.address : atm.name}</p>
                                                <p className={`${styles.distance}`}>{atm.distance.toFixed(2)}Km</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                    {
                        props.type.toLowerCase() === 'branch' &&
                        <div className='mt-5'>
                            {
                                branches.map(branch => {
                                    return (
                                        <div key={branch.id}>
                                            <div className={`d-flex justify-content-between ${styles.location}`}>
                                                <p>{branch.address}</p>
                                                <p className={`${styles.distance}`}>{branch.distance.toFixed(2)}Km</p>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                </div>
            }
        </div>
    );
}

export default AtmLocator;